import { createContext } from 'react'

export const Locale = createContext<'de' | 'fr'>('de')
